import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shopping-bag-3"><path d="M7.75 11.25V3.75H16.25V11.25M3.75 7.75H20.25V20.25H3.75V7.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShoppingBag3;
